import { push } from 'connected-react-router';
import { SET_DASHBOARD_DATA, SET_SHOP_WAIT_TIME, SET_SHOP_STATUS, SET_SHOP_TYPE } from './constants';

export const setShopStatus = isOnline => ({
  type: SET_SHOP_STATUS,
  isOnline
});

const setShopWaitTime = waitTime => ({
  type: SET_SHOP_WAIT_TIME,
  waitTime
});

export const fetchDashboardData = (shopId, idToken) => {
  return async (dispatch) => {
    const headers = new Headers();
    headers.append('Authorization', `Bearer ${idToken}`);

    const options = {
      method: 'GET',
      headers
    }

    const response = await fetch(`${process.env.REACT_APP_API_HOST}/api/kiosk/orders/today/${shopId}`, options)

    if (response.status === 200) {
      const data = await response.json();
      dispatch({ type: SET_DASHBOARD_DATA, payload: { today: data.orders } });
      dispatch(setShopStatus(data.isOnline));
      dispatch(setShopWaitTime(data.waitTime));
      dispatch({ type: SET_SHOP_TYPE, shopTypeId: data.shopTypeId });
    } else if (response.status === 401) {
      dispatch(push('/login'));
      return;
    }
  }
};